"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticateAndLoginResponseMapper = void 0;
var AuthenticateAndLoginResponseMapper = /** @class */ (function () {
    function AuthenticateAndLoginResponseMapper(data) {
        this.localData = data;
    }
    AuthenticateAndLoginResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AuthenticateAndLoginResponseMapper;
}());
exports.AuthenticateAndLoginResponseMapper = AuthenticateAndLoginResponseMapper;
//# sourceMappingURL=AuthenticateAndLoginResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/mappers/AuthenticateAndLoginResponseMapper.js
// module id = 1496
// module chunks = 8